package org.tlsys.admin.core

import org.tlsys.ui.Page

interface PageNavigation {
    suspend fun goto(pageName: String, params: Map<String, String?>):Page
    suspend fun goto(pageName: String):Page
    fun go(url:String,params:Map<String,String?> = emptyMap())
    fun getUrl(page: Page): String?
}